/*
 * @Author: zcj 13668856327
 * @Date: 2022-06-09 10:03:20
 * @LastEditors: zcj 13668856327
 * @LastEditTime: 2022-06-09 10:07:38
 * @FilePath: \ocean-shipping-3d\src\api\modules\user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/request/screenRequest'

// 登录接口
// {
//   "user_name": "string",
//   "password": "string"
// }
// export function login(data) {
//   return request({
//     method: 'post',
//     url: '/api/screen/login',
//     data
//   })
// }
export function login(data) {
    return request({
        method: 'post',
        url: '/api/login',
        data
    })
}

// // 退出接口
// export function logout() {
//     return request({
//         method: 'post',
//         url: '/api/screen/logout'
//     })
// }

// 退出接口
export function logout() {
  return request({
      method: 'post',
      url: '/api/logout'
  })
}

// 获取用户信息接口
export function getUserInfo(token) {
    return request({
        url: '/api/user/userInfo',
        method: 'post',
        token
    })
}